/** @format */

import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import withStyles from '@material-ui/core/styles/withStyles';
import adescomStyle from '../../../assets/jss/adescom/adescomStyle';
import { ItemLoaders } from '../../../core/loaders/ItemLoaders';
import MvnoBlockRequestState from '../../../interfaces/platform/MvnoBlockRequestState';
import { FormGeneralHelper } from '../../../helpers/FormGeneral';
import { store } from '../../../core/store';
import { provConstant, provReducer } from '../../../modules/provisioning/ProvisioningConnect';
import ApiCollectionResponseInterface from '../../../interfaces/api/ApiCollectionResponseInterface';
import PlusOrdersSet from '../../../interfaces/platform/PlusOrdersSet';
import PlusOrdersSetResponse from './PlusOrdersSetResponse';

interface PlusOrdersSetListCollectionInterface extends ApiCollectionResponseInterface {
    readonly 'hydra:member': Array<PlusOrdersSet> | null;
}

interface PlusOrdersGetListCollectionInterface extends ApiCollectionResponseInterface {
    readonly 'hydra:member': Array<PlusOrdersSet> | null;
}

interface PlkViewListProps {
    item: MvnoBlockRequestState;
    dispatch: any;
}

interface PlkViewListState {
    plkOrderSet: PlusOrdersSetListCollectionInterface | null;
    plkOrderGet: PlusOrdersGetListCollectionInterface | null;
}

class PlkViewList extends PureComponent<PlkViewListProps, PlkViewListState> {
    private loaderCall: ItemLoaders;

    constructor(props: PlkViewListProps, context: PlkViewListState) {
        super(props, context);
        store.injectReducer('provReducer', provReducer, false);
        this.state = {
            plkOrderSet: null,
            plkOrderGet: null,
        };
        this.loaderCall = new ItemLoaders(this.props.dispatch);
    }

    componentDidMount(): void {
        const { item } = this.props;
        this.loaderCall.getListWithCallback(
            FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/plus_orders_sets')),
            provConstant.PLK_ORDERS_ITEM,
            [{ name: 'mvnoBlockRequestStateId', value: item.id }],
            [],
            (data: PlusOrdersSetListCollectionInterface): void => {
                this.setState({
                    plkOrderSet: data,
                });
            },
            { propagateDataToCallback: true, dispatchAfterCallback: false }
        );
    }

    render():
        | React.ReactElement<any, string | React.JSXElementConstructor<any>>
        | string
        | number
        | {}
        | React.ReactNodeArray
        | React.ReactPortal
        | boolean
        | null
        | undefined {
        const { plkOrderSet, plkOrderGet } = this.state;

        if (plkOrderSet && plkOrderSet['hydra:totalItems'] !== 0 && plkOrderSet['hydra:member']) {
            return <PlusOrdersSetResponse item={plkOrderSet['hydra:member'][0]} />;
        }
        return null;
    }
}

const mapStateToProps = (state: any): object => {
    return {};
};

export default compose<any, any>(connect(mapStateToProps), withStyles(adescomStyle))(PlkViewList);
